module.exports = __webpack_public_path__ + "img/upload-icon.9f3f1088.svg";